import React from 'react';
import { Check, Sparkles } from 'lucide-react';
import { pro } from '../data/mock';

const Pro = () => {
  return (
    <section id="pro" className="py-20 md:py-28 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="relative overflow-hidden rounded-3xl p-8 md:p-12 lg:p-16" style={{ background: 'var(--gradient-hero)' }}>
          {/* Background decoration */}
          <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-green-300/20 blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full bg-yellow-300/20 blur-3xl"></div>
          
          <div className="relative grid lg:grid-cols-2 gap-10 items-center">
            {/* Content */}
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6" style={{ background: 'var(--accent-wash)' }}>
                <Sparkles size={16} style={{ color: 'var(--accent-text)' }} />
                <span className="text-sm font-medium" style={{ color: 'var(--accent-text)' }}>Pro Version</span>
              </div>
              
              <h2 className="heading-2 mb-4">{pro.title}</h2>
              <p className="body-large mb-8" style={{ color: 'var(--text-secondary)' }}>
                {pro.description}
              </p>
              
              <a
                href={pro.ctaHref}
                className="btn-primary gap-2 inline-flex"
              >
                {pro.ctaText}
              </a>
            </div>

            {/* Features List */}
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-white/50 shadow-lg">
              <h3 className="heading-3 mb-6">Pro Benefits</h3>
              <ul className="space-y-4">
                {pro.features.map((feature, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div 
                      className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
                      style={{ background: 'var(--gradient-button)' }}
                    >
                      <Check size={14} className="text-white" />
                    </div>
                    <span className="body-medium">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pro;
